import { render } from "./QuotationDetails.vue?vue&type=template&id=018d05ae&scoped=true&ts=true"
import script from "./QuotationDetails.vue?vue&type=script&lang=ts"
export * from "./QuotationDetails.vue?vue&type=script&lang=ts"

import "./QuotationDetails.vue?vue&type=style&index=0&id=018d05ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018d05ae"]])

export default __exports__